import NewQualityForm from './NewQualityForm';

export default NewQualityForm;
